import { Row } from 'antd'
import InvoiceForm from 'app/components/Core/Customer/Form/Invoice'
import OrganizationForm from 'app/components/Core/Customer/Form/Organization'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { useCurrentCustomer } from 'app/lib/hooks/useCurrent'
import useTitle from 'app/lib/hooks/useTitle'
import useTranslation from 'app/lib/hooks/useTranslation'
import { PageProps } from 'app/pages/typing'
import * as React from 'react'

const SettingIndex: React.FC<PageProps> = (props) => {
  const { title } = useTitle(props)
  const customer = useCurrentCustomer()
  const { tRoute } = useTranslation({ scope: props.route.key })

  return (
    <Row>
      <KCol span={24} card title={title}>
        <Row gutter={[0, 24]}>
          <KCol
            span={24}
            card
            cardProps={{ bordered: true }}
            title={tRoute({ id: 'organization' })}>
            <OrganizationForm member={customer} />
          </KCol>
          <KCol span={24} card cardProps={{ bordered: true }} title={tRoute({ id: 'invoice' })}>
            <InvoiceForm member={customer} />
          </KCol>
        </Row>
      </KCol>
    </Row>
  )
}

export default SettingIndex
